import { API } from "@/services"

export const CLIENTS_ENDPOINTS = {
  numberOfClients(params={}){
    return API.Axios.callstats.v1.request({
      url: `clients/number-of-clients`,
      method: 'GET',
      params,
    })
  },
}